import React from 'react';
import { useTranslation } from 'react-i18next';

import burgerImage from '@/assets/images/visibility.webp';
import visitorImage from '@/assets/images/visitors.webp';

import { LoginBento } from '../LoginBento';
import { Typography } from '@/components/atoms/Typography';
import { MRHInfos } from '@/components/molecules/MRHInfos';

export const LoginPageSidebar = () => {
  const { t } = useTranslation();
  return (
    <div className="xl:flex flex-1 relative hidden p-12 w-full h-full bg-gradient-to-br from-primary  to-orange-500 flex-col justify-between gap-2.5">
      <div className="flex  w-full justify-between">
        <div className="mt-6 space-y-2">
          <Typography variant="heroTitle" weight="medium" color="white">
            Gérer votre restaurant <strong>gratuitement</strong>
          </Typography>
        </div>
      </div>

      <div className="space-y-5 mt-5">
        <div className="grid grid-cols-2 gap-4 w-full">
          <img src={burgerImage} draggable={false} className="h-full w-full rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-l-[calc(2rem+1px)]" />
          <img src={visitorImage} draggable={false} className="h-full w-full rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-r-[calc(2rem+1px)]" />
        </div>
        <LoginBento />
        <MRHInfos />
      </div>
    </div>
  );
};
